import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient singleton, partage entre PersistQueryClientProvider et hooks.
 * Configuration plus prudente que le defaut pour eviter de spammer Graph.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:           60_000,
      gcTime:              24 * 60 * 60 * 1000,
      refetchOnWindowFocus:false,
      retry:               1,
    },
  },
});
